export default __webpack_public_path__ + "static/blog-details-1-1-0c802af99e8547d45cb7bf1b531e30c4.jpg";